import React, { useContext, useEffect, useState } from 'react';
import styles from './index.module.scss';
import { FilterContext } from './context.jsx';
import { filterGroups, filterMap } from './filterData.js';
import { useTranslation } from 'react-i18next';
import { handleGtmEvent } from '@helpers/gtm';

export const Filter = ({ enabled, toggleEnabled, name, label }) => {
  return (
    <div className={styles.ProductFilter}>
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={enabled}
        onChange={toggleEnabled}
      />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        className={styles.CheckboxCheckmark}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.08138 1.13153L4.30774 7.19401L2.3876 5.45558C2.03784 5.13885 1.49754 5.16566 1.18085 5.51545L0.607476 6.14876C0.290811 6.49853 0.317647 7.03878 0.667414 7.35545L4.10535 10.468C4.5003 10.8256 5.12263 10.7384 5.40408 10.286L10.2574 2.48556C10.5067 2.08495 10.384 1.55814 9.98337 1.30888L9.258 0.857572C8.85743 0.608341 8.33066 0.730992 8.08138 1.13153Z"
          fill="white"
        />
      </svg>
      <label htmlFor={name}>{label}</label>
    </div>
  );
};

export const FilterGroup = ({ label, groupKey }) => {
  const { filters, toggleFilter } = useContext(FilterContext);
  const { t } = useTranslation();

  return (
    <div className={styles.ProductFilterGroup}>
      <h2>{label}</h2>
      <div>
        {Object.values(filters)
          .filter((filter) =>
            filterGroups[groupKey].includes(filterMap[filter.key])
          )
          .map((filter, idx) => (
            <Filter
              enabled={filter.enabled}
              toggleEnabled={() => {
                handleGtmEvent('filter', {
                  eventParameters: {
                    omnibus: true,
                    filter_name: filter.key,
                    filter_category: label,
                  },
                });
                toggleFilter(filter.key);
              }}
              name={filter.key}
              label={t(`dashboard_Filter_${filter.key}`)}
              key={`filter-${idx}`}
            />
          ))}
      </div>
    </div>
  );
};

export const ClearFilterTags = () => {
  const { toggleFilter, getEnabledFilters, clearFilters } =
    useContext(FilterContext);
  const [enabledFilters, setEnabledFilters] = useState(getEnabledFilters());
  const { t } = useTranslation();

  useEffect(() => {
    setEnabledFilters(getEnabledFilters());
  }, [getEnabledFilters]);

  if (!getEnabledFilters().length) {
    return null;
  }

  return (
    <div className={styles.ClearAllSection}>
      {enabledFilters.length > 1 ? (
        <button className={styles.ClearFiltersButton} onClick={clearFilters}>
          {t('dashboard_Filter_ClearFilters')}
        </button>
      ) : null}
      <div className={styles.ClearFilterBadgeGroup}>
        {enabledFilters.map((enabledFilter) => {
          return (
            <button
              className={styles.ClearFilterBadge}
              onClick={() => toggleFilter(enabledFilter.key)}
              key={`clear-filter-${enabledFilter.key}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.2426 17.6897L12 13.447L7.75735 17.6897L6.34314 16.2755L10.5858 12.0328L6.34314 7.79019L7.75735 6.37598L12 10.6186L16.2426 6.37598L17.6568 7.79019L13.4142 12.0328L17.6568 16.2755L16.2426 17.6897Z"
                  fill="#0054A4"
                />
              </svg>
              <p>{t(`dashboard_Filter_${enabledFilter.key}`)}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export const FilterGroupBlock = () => {
  const { t } = useTranslation();

  return (
    <>
      {Object.keys(filterGroups).map((filterGroupKey, idx) => (
        <FilterGroup
          label={t(`dashboard_FilterGroup_${filterGroupKey}`)}
          groupKey={filterGroupKey}
          key={`filter-group-${idx}`}
        />
      ))}
    </>
  );
};

export const FilterGroups = () => {
  const { t } = useTranslation();
  return (
    <section className={styles.ProductFilterGroups}>
      <h1>{t('dashboard_Filter_Text')}</h1>
      <ClearFilterTags />
      <div className={styles.ProductFilterDivider} />
      <div className={styles.DesktopFilterColumn}>
        <FilterGroupBlock />
      </div>
    </section>
  );
};
